import { useEffect, useRef, useState } from 'react';
import { ColorRing } from 'react-loader-spinner';

import { useGetTableMCTColumns } from './useGetTableMCTColumns';
import TrapDeviceExpandable from './TableMCTExpandable';

import { TrapDevice } from 'api/traps/DevicesWareHouse/types';
import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useScreenSize from 'hooks/Screen/useScreenSize';
import MultiCatchMouseTrapIcon from 'components/Icons/MultiCatchMouseTrapIcon';
import { TrapType } from 'components/AnalyticsPage/TrapType';

interface Props {
  data: TrapDevice[] | undefined;
  isAll: boolean;
  isLoading: boolean;
  isRefetching: boolean;
  refetch: () => void;
}

const TableMCT: React.FC<Props> = ({ isAll, data, isLoading, isRefetching, refetch }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const columns = useGetTableMCTColumns(isAll, TrapType.MCT);
  const { isNotLargeDesktop, isNotMobile } = useScreenSize();
  const isAllRef = useRef(isAll);

  useEffect(() => {
    isAllRef.current = isAll;
    refetch();
  }, [page, ordering, search, refetch, isAll]);

  return (
    <div className="flex-fill">
      {(isLoading || isRefetching) && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
          }}
        >
          <ColorRing
            visible
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            wrapperStyle={{}}
            wrapperClass="color-ring-wrapper"
            colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
          />
        </div>
      )}
      <div className="bg-white">
        <FilterDataTable<TrapDevice>
          columns={columns}
          data={data || []}
          title="Multi-catch mouse traps"
          iconComponent={<MultiCatchMouseTrapIcon />}
          isMinHeight
          onChangePage={setPage}
          onChangeFilterParams={setQueryParam}
          onChangeSearch={setSearch}
          isLoading={isLoading}
          expandableRows={isAllRef.current ? isNotLargeDesktop : isNotMobile}
          expandableRowsComponent={row => <TrapDeviceExpandable data={row.data} isAll={isAll} />}
        />
      </div>
    </div>
  );
};

export default TableMCT;
